import React from 'react';
import { AlertTriangle, Plus, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Claims = () => {
  return (
    <div className="bg-white">
      {/* Page Header */}
      <div className="page-header">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="page-header-title">Claims</h1>
            <p className="page-header-subtitle">Process and track insurance claims</p>
          </div>
          <button className="btn btn-primary mt-4 sm:mt-0">
            <Plus className="h-4 w-4 mr-2" />
            New Claim
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div className="px-6 py-12 sm:px-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <AlertTriangle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Claims Management</h2>
            <p className="text-gray-600 mb-6">
              This feature is coming soon. Claims processing functionality will be available in a future update.
            </p>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-6">
            <h3 className="font-semibold text-amber-900 mb-2">Expected Features</h3>
            <ul className="text-amber-800 text-sm space-y-2 mb-4">
              <li className="flex items-start">
                <span className="mr-3">•</span>
                <span>Submit and track new claims</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3">•</span>
                <span>Monitor claim processing status</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3">•</span>
                <span>Upload supporting documentation</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3">•</span>
                <span>View claim history and settlements</span>
              </li>
            </ul>
          </div>

          <div className="border border-gray-200 rounded-lg p-6 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">In the Meantime</h3>
            <p className="text-gray-600 text-sm mb-4">
              You can continue to manage client information and policies through the Clients section.
            </p>
            <Link
              to="/clients"
              className="text-slate-600 hover:text-slate-900 font-medium inline-flex items-center text-sm"
            >
              Go to Clients
              <ArrowRight className="h-4 w-4 ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Claims;
